export const categories = [
  {
    id: 'tech-discuss',
    name: '技术交流',
    slug: 'tech-discuss',
    description: '编程开发、前端技术、后端架构等技术话题讨论',
    icon: 'ri-code-s-slash-line',
    color: 'primary',
    articleCount: 2341,
    todayPosts: 128,
  },
  {
    id: 'life-share',
    name: '生活分享',
    slug: 'life-share',
    description: '日常生活、美食旅游、摄影爱好等生活点滴',
    icon: 'ri-camera-lens-line',
    color: 'accent',
    articleCount: 1892,
    todayPosts: 96,
  },
  {
    id: 'digital-product',
    name: '数码产品',
    slug: 'digital-product',
    description: '手机电脑、智能家居、数码评测与选购指南',
    icon: 'ri-smartphone-line',
    color: 'primary',
    articleCount: 1567,
    todayPosts: 87,
  },
  {
    id: 'game-entertainment',
    name: '游戏娱乐',
    slug: 'game-entertainment',
    description: '热门游戏攻略、电竞资讯、动漫影视讨论',
    icon: 'ri-gamepad-line',
    color: 'accent',
    articleCount: 3210,
    todayPosts: 205,
  },
  {
    id: 'career-education',
    name: '职场教育',
    slug: 'career-education',
    description: '求职面试、职业规划、在线学习与技能提升',
    icon: 'ri-book-open-line',
    color: 'primary',
    articleCount: 1102,
    todayPosts: 56,
  },
  {
    id: 'car-travel',
    name: '汽车出行',
    slug: 'car-travel',
    description: '新车评测、自驾游记、交通出行话题交流',
    icon: 'ri-car-line',
    color: 'accent',
    articleCount: 987,
    todayPosts: 43,
  },
  {
    id: 'health-fitness',
    name: '健康养生',
    slug: 'health-fitness',
    description: '运动健身、营养饮食、心理健康与养生知识',
    icon: 'ri-heart-pulse-line',
    color: 'primary',
    articleCount: 876,
    todayPosts: 38,
  },
  {
    id: 'finance-invest',
    name: '财经投资',
    slug: 'finance-invest',
    description: '股票基金、理财规划、房产楼市与经济走势',
    icon: 'ri-funds-line',
    color: 'accent',
    articleCount: 1456,
    todayPosts: 72,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};